// Must be the first import: it sets the window globals the embedded signing component
// reads when its module is evaluated (see setupSigningEnv). Keep it ahead of every other
// import — do not let the import sorter move it.
// eslint-disable-next-line simple-import-sort/imports
import './setupSigningEnv';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';

import 'reflect-metadata';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);

reportWebVitals();
